export default {
  doctor:
    'Fixed fee for primary care or specialist visits when you incur an accident or illness.',
  prescription: 'Fixed fee for many prescription drugs depending on their type.',
  preventive:
    'Depending on the plan you select, preventive care is covered for up to a specified dollar amount.',
  telemedicine:
    'Free online virtual visits with a board-certified physician who can diagnose and prescribe medications when applicable.',
  child:
    'Vaccinations to help the spread of infectious diseases are paid at either 100% or are subject to coinsurance, but not the deductible.',
  supplemental:
    'Coverage help on inpatient or outpatient expenses due to accidental injury. Select plans offer this as part of the policy or as an optional benefit.',
  contraceptive:
    'Add Optional prescription drug benefits which include FDA-approved contraceptive drugs and devices.',
  patientAdvocacy:
    'Use our patient advocates to help find a local doctor and schedule appointments. Once the claims process is complete and you have the final bill that is your responsibility, Point Health can help negotiate down your final total or establish a payment plan that works for you.'
}
